/**
 * Do not edit this file manually!
 *
 * It is generated by scripts/dev/generate_fontawesome_manifest.rb
 * Use something like class="fa-solid fa-star" in a view/template/component and rerun the script
 */

import { library, dom, config } from "@fortawesome/fontawesome-svg-core";
import {
  faAdjust as faSolidAdjust,
  faAngleLeft as faSolidAngleLeft,
  faAngleRight as faSolidAngleRight,
  faArchive as faSolidArchive,
  faArrowCircleUp as faSolidArrowCircleUp,
  faArrowDown as faSolidArrowDown,
  faArrowLeft as faSolidArrowLeft,
  faArrowRight as faSolidArrowRight,
  faArrowUpRightFromSquare as faSolidArrowUpRightFromSquare,
  faArrowsRotate as faSolidArrowsRotate,
  faArrowsUpDownLeftRight as faSolidArrowsUpDownLeftRight,
  faBan as faSolidBan,
  faBars as faSolidBars,
  faCalendar as faSolidCalendar,
  faCaretDown as faSolidCaretDown,
  faCaretLeft as faSolidCaretLeft,
  faChartBar as faSolidChartBar,
  faCheck as faSolidCheck,
  faChevronCircleDown as faSolidChevronCircleDown,
  faChevronRight as faSolidChevronRight,
  faCircle as faSolidCircle,
  faCircleInfo as faSolidCircleInfo,
  faCirclePlus as faSolidCirclePlus,
  faCircleQuestion as faSolidCircleQuestion,
  faClock as faSolidClock,
  faCloudDownload as faSolidCloudDownload,
  faCodeFork as faSolidCodeFork,
  faCogs as faSolidCogs,
  faEllipsisH as faSolidEllipsisH,
  faExclamationTriangle as faSolidExclamationTriangle,
  faEye as faSolidEye,
  faEyeSlash as faSolidEyeSlash,
  faFile as faSolidFile,
  faFolder as faSolidFolder,
  faFolderOpen as faSolidFolderOpen,
  faGears as faSolidGears,
  faGlobe as faSolidGlobe,
  faGripDots as faSolidGripDots,
  faInfoCircle as faSolidInfoCircle,
  faLock as faSolidLock,
  faMessageXmark as faSolidMessageXmark,
  faPaintbrush as faSolidPaintbrush,
  faPencil as faSolidPencil,
  faPipe as faSolidPipe,
  faPlus as faSolidPlus,
  faRefresh as faSolidRefresh,
  faRotateLeft as faSolidRotateLeft,
  faRss as faSolidRss,
  faSave as faSolidSave,
  faSearch as faSolidSearch,
  faShare as faSolidShare,
  faShield as faSolidShield,
  faShieldHalved as faSolidShieldHalved,
  faSort as faSolidSort,
  faSortDown as faSolidSortDown,
  faSortUp as faSolidSortUp,
  faSpinner as faSolidSpinner,
  faSquare as faSolidSquare,
  faStar as faSolidStar,
  faTimes as faSolidTimes,
  faTrash as faSolidTrash,
  faTriangleExclamation as faSolidTriangleExclamation,
  faUnlock as faSolidUnlock,
  faUser as faSolidUser,
  faUserCircle as faSolidUserCircle,
  faUserMinus as faSolidUserMinus,
  faUserPlus as faSolidUserPlus,
  faUserSecret as faSolidUserSecret,
  faUserTimes as faSolidUserTimes,
  faUserXmark as faSolidUserXmark,
  faUsers as faSolidUsers,
  faXmark as faSolidXmark,
} from "@fortawesome/pro-solid-svg-icons";
import {
  faDailymotion as faBrandsDailymotion,
  faDeviantart as faBrandsDeviantart,
  faFacebook as faBrandsFacebook,
  faFlickr as faBrandsFlickr,
  faInstagram as faBrandsInstagram,
  faKickstarter as faBrandsKickstarter,
  faMicrosoft as faBrandsMicrosoft,
  faSlideshare as faBrandsSlideshare,
  faSoundcloud as faBrandsSoundcloud,
  faSpotify as faBrandsSpotify,
  faTwitter as faBrandsTwitter,
  faVimeo as faBrandsVimeo,
  faXTwitter as faBrandsXTwitter,
  faYoutube as faBrandsYoutube,
} from "@fortawesome/free-brands-svg-icons";
import {
  faAddressBook as faRegularAddressBook,
  faArrowLeft as faRegularArrowLeft,
  faArrowsRepeat as faRegularArrowsRepeat,
  faBolt as faRegularBolt,
  faBoxArchive as faRegularBoxArchive,
  faBriefcase as faRegularBriefcase,
  faBullhorn as faRegularBullhorn,
  faCalendar as faRegularCalendar,
  faCalendarDay as faRegularCalendarDay,
  faCheck as faRegularCheck,
  faCheckSquare as faRegularCheckSquare,
  faChevronDown as faRegularChevronDown,
  faChevronUp as faRegularChevronUp,
  faCircle as faRegularCircle,
  faCircleInfo as faRegularCircleInfo,
  faCirclePlus as faRegularCirclePlus,
  faCircleUser as faRegularCircleUser,
  faClock as faRegularClock,
  faClone as faRegularClone,
  faCloudDownload as faRegularCloudDownload,
  faComments as faRegularComments,
  faComputerClassic as faRegularComputerClassic,
  faEarthEurope as faRegularEarthEurope,
  faEdit as faRegularEdit,
  faEllipsis as faRegularEllipsis,
  faEllipsisVertical as faRegularEllipsisVertical,
  faEnvelope as faRegularEnvelope,
  faEye as faRegularEye,
  faEyeSlash as faRegularEyeSlash,
  faFile as faRegularFile,
  faFileChartPie as faRegularFileChartPie,
  faFileExcel as faRegularFileExcel,
  faFilePdf as faRegularFilePdf,
  faFilePowerpoint as faRegularFilePowerpoint,
  faFileWord as faRegularFileWord,
  faFiles as faRegularFiles,
  faFilter as faRegularFilter,
  faFolder as faRegularFolder,
  faFolderOpen as faRegularFolderOpen,
  faGear as faRegularGear,
  faGlobe as faRegularGlobe,
  faHandshake as faRegularHandshake,
  faInbox as faRegularInbox,
  faLanguage as faRegularLanguage,
  faLocationDot as faRegularLocationDot,
  faMapLocationDot as faRegularMapLocationDot,
  faMobile as faRegularMobile,
  faNewspaper as faRegularNewspaper,
  faPaperPlane as faRegularPaperPlane,
  faPaperclipVertical as faRegularPaperclipVertical,
  faPencil as faRegularPencil,
  faPencilSquare as faRegularPencilSquare,
  faPlus as faRegularPlus,
  faPowerOff as faRegularPowerOff,
  faSearch as faRegularSearch,
  faSidebar as faRegularSidebar,
  faSpinner as faRegularSpinner,
  faSquare as faRegularSquare,
  faStar as faRegularStar,
  faTable as faRegularTable,
  faTerminal as faRegularTerminal,
  faTrash as faRegularTrash,
  faTriangleExclamation as faRegularTriangleExclamation,
  faUser as faRegularUser,
  faUserCircle as faRegularUserCircle,
  faUserPlus as faRegularUserPlus,
  faUserShield as faRegularUserShield,
  faUserXmark as faRegularUserXmark,
  faUsers as faRegularUsers,
  faXmark as faRegularXmark,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faCloudArrowDown as faLightCloudArrowDown,
  faEnvelope as faLightEnvelope,
  faFile as faLightFile,
  faFileAudio as faLightFileAudio,
  faFileCode as faLightFileCode,
  faFileCsv as faLightFileCsv,
  faFileExcel as faLightFileExcel,
  faFileImage as faLightFileImage,
  faFileLines as faLightFileLines,
  faFilePdf as faLightFilePdf,
  faFilePowerpoint as faLightFilePowerpoint,
  faFileVideo as faLightFileVideo,
  faFileWord as faLightFileWord,
  faFileZipper as faLightFileZipper,
  faImage as faLightImage,
  faMobileScreenButton as faLightMobileScreenButton,
} from "@fortawesome/pro-light-svg-icons";
import {
  faChartSimple as faDuotoneChartSimple,
  faMedal as faDuotoneMedal,
  faUsers as faDuotoneUsers,
} from "@fortawesome/pro-duotone-svg-icons";

config.autoReplaceSvg = "nest";

library.add(
  faBrandsDailymotion,
  faBrandsDeviantart,
  faBrandsFacebook,
  faBrandsFlickr,
  faBrandsInstagram,
  faBrandsKickstarter,
  faBrandsMicrosoft,
  faBrandsSlideshare,
  faBrandsSoundcloud,
  faBrandsSpotify,
  faBrandsTwitter,
  faBrandsVimeo,
  faBrandsXTwitter,
  faBrandsYoutube,
  faDuotoneChartSimple,
  faDuotoneMedal,
  faDuotoneUsers,
  faLightCloudArrowDown,
  faLightEnvelope,
  faLightFile,
  faLightFileAudio,
  faLightFileCode,
  faLightFileCsv,
  faLightFileExcel,
  faLightFileImage,
  faLightFileLines,
  faLightFilePdf,
  faLightFilePowerpoint,
  faLightFileVideo,
  faLightFileWord,
  faLightFileZipper,
  faLightImage,
  faLightMobileScreenButton,
  faRegularAddressBook,
  faRegularArrowLeft,
  faRegularArrowsRepeat,
  faRegularBolt,
  faRegularBoxArchive,
  faRegularBriefcase,
  faRegularBullhorn,
  faRegularCalendar,
  faRegularCalendarDay,
  faRegularCheck,
  faRegularCheckSquare,
  faRegularChevronDown,
  faRegularChevronUp,
  faRegularCircle,
  faRegularCircleInfo,
  faRegularCirclePlus,
  faRegularCircleUser,
  faRegularClock,
  faRegularClone,
  faRegularCloudDownload,
  faRegularComments,
  faRegularComputerClassic,
  faRegularEarthEurope,
  faRegularEdit,
  faRegularEllipsis,
  faRegularEllipsisVertical,
  faRegularEnvelope,
  faRegularEye,
  faRegularEyeSlash,
  faRegularFile,
  faRegularFileChartPie,
  faRegularFileExcel,
  faRegularFilePdf,
  faRegularFilePowerpoint,
  faRegularFileWord,
  faRegularFiles,
  faRegularFilter,
  faRegularFolder,
  faRegularFolderOpen,
  faRegularGear,
  faRegularGlobe,
  faRegularHandshake,
  faRegularInbox,
  faRegularLanguage,
  faRegularLocationDot,
  faRegularMapLocationDot,
  faRegularMobile,
  faRegularNewspaper,
  faRegularPaperPlane,
  faRegularPaperclipVertical,
  faRegularPencil,
  faRegularPencilSquare,
  faRegularPlus,
  faRegularPowerOff,
  faRegularSearch,
  faRegularSidebar,
  faRegularSpinner,
  faRegularSquare,
  faRegularStar,
  faRegularTable,
  faRegularTerminal,
  faRegularTrash,
  faRegularTriangleExclamation,
  faRegularUser,
  faRegularUserCircle,
  faRegularUserPlus,
  faRegularUserShield,
  faRegularUserXmark,
  faRegularUsers,
  faRegularXmark,
  faSolidAdjust,
  faSolidAngleLeft,
  faSolidAngleRight,
  faSolidArchive,
  faSolidArrowCircleUp,
  faSolidArrowDown,
  faSolidArrowLeft,
  faSolidArrowRight,
  faSolidArrowUpRightFromSquare,
  faSolidArrowsRotate,
  faSolidArrowsUpDownLeftRight,
  faSolidBan,
  faSolidBars,
  faSolidCalendar,
  faSolidCaretDown,
  faSolidCaretLeft,
  faSolidChartBar,
  faSolidCheck,
  faSolidChevronCircleDown,
  faSolidChevronRight,
  faSolidCircle,
  faSolidCircleInfo,
  faSolidCirclePlus,
  faSolidCircleQuestion,
  faSolidClock,
  faSolidCloudDownload,
  faSolidCodeFork,
  faSolidCogs,
  faSolidEllipsisH,
  faSolidExclamationTriangle,
  faSolidEye,
  faSolidEyeSlash,
  faSolidFile,
  faSolidFolder,
  faSolidFolderOpen,
  faSolidGears,
  faSolidGlobe,
  faSolidGripDots,
  faSolidInfoCircle,
  faSolidLock,
  faSolidMessageXmark,
  faSolidPaintbrush,
  faSolidPencil,
  faSolidPipe,
  faSolidPlus,
  faSolidRefresh,
  faSolidRotateLeft,
  faSolidRss,
  faSolidSave,
  faSolidSearch,
  faSolidShare,
  faSolidShield,
  faSolidShieldHalved,
  faSolidSort,
  faSolidSortDown,
  faSolidSortUp,
  faSolidSpinner,
  faSolidSquare,
  faSolidStar,
  faSolidTimes,
  faSolidTrash,
  faSolidTriangleExclamation,
  faSolidUnlock,
  faSolidUser,
  faSolidUserCircle,
  faSolidUserMinus,
  faSolidUserPlus,
  faSolidUserSecret,
  faSolidUserTimes,
  faSolidUserXmark,
  faSolidUsers,
  faSolidXmark,
);

dom.watch();
